/* __next_internal_client_entry_do_not_use__ Canada auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=13%3A397))
 * @trackcomponent
 * @lastsynced 2023-11-30T15:50:25.218Z
 */ export var Canada = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("rect", {
            x: "1",
            y: "1",
            width: "16",
            height: "12",
            fill: "white",
            stroke: "#757575"
        }),
        /*#__PURE__*/ _jsx("rect", {
            x: "1",
            y: "1",
            width: "4",
            height: "12",
            fill: "#B64343"
        }),
        /*#__PURE__*/ _jsx("rect", {
            x: "13",
            y: "1",
            width: "4",
            height: "12",
            fill: "#B64343"
        }),
        /*#__PURE__*/ _jsx("rect", {
            x: "1",
            y: "1",
            width: "16",
            height: "12",
            stroke: "#757575"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M8.99902 7.49414V9.5008",
            stroke: "#B64343",
            strokeWidth: "0.5",
            strokeMiterlimit: "10",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M11.5 7.29599L11.1565 7.14035L11.392 6.2732L10.6108 6.43996L10.4668 6.02306L9.69668 6.7707L9.97091 5.21428L9.48338 5.4533L8.99862 4.5L8.51385 5.4533L8.02909 5.21428L8.30055 6.7707L7.53047 6.02306L7.3892 6.43996L6.60526 6.2732L6.84349 7.14035L6.5 7.29599L7.63573 8.30488L7.49446 8.88853L8.99862 8.38826L10.5028 8.88853L10.3615 8.30488L11.5 7.29599Z",
            fill: "#B64343"
        })
    ]
}), "Canada", function(strictLocalize) {
    return {
        viewBox: "0 0 18 14",
        fill: "none",
        titleAccess: strictLocalize({
            id: "zv7O/l",
            defaultMessage: [
                {
                    type: 0,
                    value: "Canada flag"
                }
            ]
        })
    };
});
